import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

/**
 * @param { Ref<HTMLElement> } containerRef
 * @param { Function } resizeFn
 **/
export default function useSize(containerRef, activeSize, resizeFn = () => void 0, shouldReset = true, activeHeightType, branded = ref(false)) {
  const containerWidth = ref(640) // set to default widget size
  const containerHeight = ref(600) // set to default widget height

  const paddinglessWidth = computed(() => containerWidth.value - 16)

  const resize = async () => {
    containerWidth.value = containerRef.value?.offsetWidth
    containerHeight.value = containerRef.value?.offsetHeight

    resizeFn(containerWidth)
  }

  const initListeners = async () => {
    // set initial size when widget is mounted
    await resize()
    // schedule listener for resize
    window.addEventListener('resize', resize)
  }

  const removeListeners = () => {
    window.removeEventListener('resize', resize)
  }

  const unwatch = watch(activeSize, newActiveSize => {
    if (newActiveSize === 'full-width') {
      containerWidth.value = containerRef.value?.offsetWidth
      resizeFn(containerWidth)
    } else {
      containerWidth.value = newActiveSize
      resizeFn(containerWidth)
    }
  })

  const unwatchHeightChange = watch(activeHeightType, async () => {
    await nextTick(() => {
      containerHeight.value = containerRef.value.offsetHeight
    })
  })

  const unwatchBranded = watch(branded, async () => {
    await nextTick(() => {
      containerHeight.value = containerRef.value.offsetHeight
    })
  })

  onMounted(async () => {
    await initListeners()
  })

  onBeforeUnmount(() => {
    if (shouldReset) {
      removeListeners()
      unwatch()
      unwatchHeightChange()
      unwatchBranded()
    }
  })

  return {
    width: containerWidth,
    height: containerHeight,
    paddinglessWidth: paddinglessWidth,
    resize
  }
}
